import { useTranslation } from 'react-i18next';
import FeatureLayout from '../components/layout/FeatureLayout';
import SEOHead from '../components/common/SEOHead';
import PricingTable from '../components/subscription/PricingTable';

export default function Pricing() {
  const { t } = useTranslation('landing');
  const { t: tf } = useTranslation('features');

  return (
    <FeatureLayout
      breadcrumbs={[
        { label: tf('pricingLink') },
      ]}
    >
      <SEOHead
        title="Tarifs"
        description="Découvrez les tarifs de Splinity. Commencez gratuitement, passez à l'offre Premium ou Duo quand vous êtes prêt."
        path="/tarifs"
      />

      <section className="py-20 px-4 sm:px-6 lg:px-8">
        <div className="max-w-5xl mx-auto">
          <div className="text-center mb-12">
            <h1 className="pub-title text-3xl sm:text-4xl font-bold mb-4">
              {t('pricing.sectionTitle')}
            </h1>
            <p className="pub-muted text-lg max-w-2xl mx-auto">
              {t('pricing.sectionSubtitle')}
            </p>
          </div>

          <PricingTable variant="landing" />
        </div>
      </section>
    </FeatureLayout>
  );
}
